import React, { useState } from "react";
import {
  TextField,
  DatePicker,
  PrimaryButton,
  Stack,
  Label,
  mergeStyleSets,
  PanelType,
  DefaultButton,
  SelectionMode,
  Panel,
  Spinner,
  SpinnerSize
} from "@fluentui/react";
import useAxios from "axios-hooks";
import DetailsTable from "../../../../Table/DetailsTable";
import { axiosInstance } from '../../../../../api/config';
import ManageUsers from "./ManageUsers";
import FeatureSummary from "../../../../Util/FeatureSummary";
import env from "../../../../../env";
const { REACT_APP_API_BASE_URI } = env;


// Define styles using Fluent UI's mergeStyleSets
const styles = mergeStyleSets({
  formRow: {
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
  },
  label: {
    flex: "1 0 25%",
  },
  input: {
    flex: "1 0 75%",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
  },
  listContainer: {
    marginTop: "20px",
  },
});

const MemberLookup = () => {
  // State variables for form fields
  const [memberId, setMemberId] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [cobrand, setCobrand] = useState();
  const [username, setUsername] = useState();
  const [altEmail, setAltEmail] = useState();
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const openPanel = (item) => {
    setSelectedItem(item);
    setIsPanelOpen(true);
  };



  // State variable for grid data
  const [gridData, setGridData] = useState([]);

  const [{ loading, error }, execute] = useAxios(
    {
      url: `2020-05-05/user/lookup`,
      method: "POST",
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance, manual: true }
  );

  const handleSubmit = async () => {
    setSubmitted(false);
    const payload = {
      MemberID: memberId ? memberId : null,
      First: fname ? fname : null,
      Last: lname ? lname : null,
      CoBrand: cobrand ? cobrand : null,
      Username: username ? username : null,
      AltEmail: altEmail ? altEmail : null,
    };

    try {
      const response = await execute({ data: payload });
      setGridData(response.data);
      setSubmitted(true); // Set after successful response
    } catch (err) {
      console.error("Error fetching member lookup data:", err);
      setSubmitted(true); // Still set to true to show fallback if needed
    }
  };

  const closePanel = async () => {
    setSelectedItem(null);
    setIsPanelOpen(false);
  };

  const columns = [
    {
      key: "edit",
      name: "",
      minWidth: 170,
      onRender: (item) => (
        <DefaultButton text="Manage User" onClick={() => openPanel(item)} />
      ),
    },
    { key: "memberID", name: "MemberID", fieldName: "memberID", minWidth: 80 },
    { key: "personid", name: "PersonId", fieldName: "personID", minWidth: 80 },
    { key: "type", name: "Type", fieldName: "type", minWidth: 50 },
    { key: "status", name: "Status", fieldName: "status", minWidth: 70 },
    { key: "regType", name: "RegType", fieldName: "regType", minWidth: 70 },
    { key: "ssoterms", name: "SSO Terms", fieldName: "ssoTerms", minWidth: 80 },
    { key: "first", name: "First", fieldName: "first", minWidth: 100 },
    { key: "last", name: "Last", fieldName: "last", minWidth: 100 },
    { key: "cbid", name: "CBID", fieldName: "cbid", minWidth: 50 },
    { key: "cb", name: "CoBrand", fieldName: "cb", minWidth: 70 },
    { key: "username", name: "Username", fieldName: "username", minWidth: 150 },
    { key: "altEmail", name: "AltEmail", fieldName: "altEmail", minWidth: 150 },
    { key: "yob", name: "YOB", fieldName: "yob", minWidth: 100 },
    { key: "id1", name: "ID1", fieldName: "id1", minWidth: 120 },
    { key: "id2", name: "ID2", fieldName: "id2", minWidth: 120 },
    { key: "regDate", name: "RegDate", fieldName: "regDate", minWidth: 100 },
    { key: "excludeFromReports", name: "Exclude From Reports", fieldName: "excludeFromReports", minWidth: 150 },
  ];

  return (
    <div style={{ padding: '0 0 0 20px' }}>
      <h3>Member Lookup</h3>
      <div style={{ width: 400 }}>
        <Stack tokens={{ childrenGap: 0 }}>
          <div className={styles.formRow}>
            <Label className={styles.label}>MemberId</Label>
            <TextField
              className={styles.input}
              value={memberId}
              onChange={(e, newValue) => setMemberId(newValue || "")}
            />
          </div>
          <div className={styles.formRow}>
            <Label className={styles.label}>First Name</Label>
            <TextField
              className={styles.input}
              value={fname}
              onChange={(e, newValue) => setFname(newValue || "")}
            />
          </div>
          <div className={styles.formRow}>
            <Label className={styles.label}>Last Name</Label>
            <TextField
              className={styles.input}
              value={lname}
              onChange={(e, newValue) => setLname(newValue || "")}
            />
          </div>
          <div className={styles.formRow}>
            <Label className={styles.label}>Cobrand</Label>
            <TextField
              className={styles.input}
              value={cobrand}
              onChange={(e, newValue) => setCobrand(newValue || "")}
            />
          </div>
          <div className={styles.formRow}>
            <Label className={styles.label}>Username</Label>
            <TextField
              className={styles.input}
              value={username}
              onChange={(e, newValue) => setUsername(newValue || "")}
            />
          </div>
          <div className={styles.formRow}>
            <Label className={styles.label}>Alt Email</Label>
            <TextField
              className={styles.input}
              value={altEmail}
              onChange={(e, newValue) => setAltEmail(newValue || "")}
            />
          </div>
          <div className={styles.buttonRow}>
            <PrimaryButton onClick={handleSubmit} disabled={loading}>Lookup</PrimaryButton>
          </div>
        </Stack>
      </div>

      {loading && (
        <div style={{ marginTop: 20 }}>
          <Spinner size={SpinnerSize.large} label="Looking up members..." />
        </div>
      )}

      {gridData?.length > 0 && <div className={styles.listContainer}>
        <DetailsTable
          items={gridData}
          columns={columns}
          detailsListProps={{ selectionMode: SelectionMode.none }}
          loading={loading}
          mainColumn={"actionItemTitle"}
          style={{
            position: "relative",
            height: "80vh",
            width: "80vw",
          }}
        />
      </div>}
      {!loading && submitted && (!gridData || gridData.length === 0) && (
        <div style={{ marginTop: 20, color: 'gray' }}>No members found.</div>
      )}
      <Panel
        isOpen={isPanelOpen}
        onDismiss={closePanel}
        headerText={"Manage User"}
        closeButtonAriaLabel="Close"
        customWidth={480}
        type={PanelType.custom}
        styles={{
          main: {
            top: 20,
            right: 20,
            bottom: 20,
            position: "absolute",
            borderRadius: "10px", // Rounded corners
            overflow: "hidden", // Prevents inner content overflow on rounded edges
          },
        }}
      >
        <ManageUsers memberId={selectedItem?.memberID} updateGrid={handleSubmit} />
      </Panel>
      <FeatureSummary
          label="About Member Lookup"
          summary="Enter a member's id, username or other details to look up their account information. The results will display a list of users matching the criteria, along with options to manage each user."
      />
    </div>
  );
};

export default MemberLookup;
